<div class="modal-dialog modal-dialog-centered modal-lg">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title text-break"><strong>Visualizar
          Empresa</strong></h5>
      <button type="button" (click)="onClose()"
        class="btn btn-fade-secondary btn-icon-block" data-dismiss="modal"
        aria-label="Close">
        <i class="material-icons">close</i>
      </button>
    </div>
    <div class="modal-body" *ngIf="!loading">
      <div class="row mb-3">
        <div class="col-lg-10">
          <p class="text-secondary" i18n>Nome:</p>
          <p i18n>{{ company?.name }}</p>
        </div>
        <div class="col-lg-2">
          <p class="text-secondary" i18n>Habilitado</p>
          <div class="custom-control custom-switch">
            <label class="custom-control-label"
              [ngClass]="{ checked: company?.enabled }">
              <input type="checkbox" class="form-control custom-control-input">
            </label>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-lg-12">
          <p class="text-secondary" i18n>CNPJ:</p>
          <p i18n>{{ convertCNPJ(company?.cnpj) || '-' }}</p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-lg-12">
          <p class="text-secondary" i18n>Contratos:</p>
          <p i18n>
            <span class="badge badge-primary mr-1"
              *ngFor="let id of company?.contractIds">{{ id }}</span>
            <span *ngIf="company?.contractIds.length === 0">-</span>
          </p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-lg-10">
          <p class="text-secondary" i18n>Endereço:</p>
          <p i18n>{{ company?.Address?.street || '-' }}</p>
        </div>
        <div class="col-lg-2">
          <p class="text-secondary" i18n>Número:</p>
          <p i18n>{{ company?.Address?.number || '-' }}</p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-lg-2">
          <p class="text-secondary" i18n>CEP:</p>
          <p i18n>{{ company?.Address?.zipcode || '-' }}</p>
        </div>
        <div class="col-lg-2">
          <p class="text-secondary" i18n>País:</p>
          <p i18n>{{ regionById[company?.regionId]?.name || '-' }}</p>
        </div>
        <div class="col-lg-2">
          <p class="text-secondary" i18n>Estado:</p>
          <p i18n>{{ company?.City?.State?.abbreviation || '-' }}</p>
        </div>
        <div class="col-lg-3">
          <p class="text-secondary" i18n>Cidade:</p>
          <p i18n>{{ company?.City?.name || '-' }}</p>
        </div>
        <div class="col-lg-3">
          <p class="text-secondary" i18n>Bairro:</p>
          <p i18n>{{ company?.Address?.neighborhood || '-' }}</p>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-lg-12">
          <p class="text-secondary" i18n>Logo:</p>
          <span
            *ngIf="company?.logo !== null && company?.logo.split('.com/')[1].split('?')[0] !== 'undefined'">
            <img [src]="company?.logo" class="logo" class="company-logo">
          </span>
          <span
            *ngIf="!company?.logo || company?.logo.split('.com/')[1].split('?')[0] === 'undefined'">
            <app-avatar [user]="{ name: company?.name || 'S N' }"
              class="avatar-userGroup-list"></app-avatar>
          </span>
        </div>
      </div>
    </div>
    <div class="loading-page" *ngIf="loading">
      <div class="loading-spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</div>
